// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAv8gngb98nKPgmvRvM4TKWnBjEGPV4378",
  authDomain: "xfinance-12e10.firebaseapp.com",
  databaseURL: "https://xfinance-12e10-default-rtdb.firebaseio.com",
  projectId: "xfinance-12e10",
  storageBucket: "xfinance-12e10.firebasestorage.app",
  messagingSenderId: "721068791830",
  appId: "1:721068791830:web:7360796feca54f2815bd37",
  measurementId: "G-4LDENDNVXR",
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa servicios específicos de Firebase
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);

// Exporta los servicios para usarlos en otros archivos
export { auth, db, storage, messaging, analytics, app as default };
